import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizHtmlEditor from "@/components/quiz/QuizHtmlEditor.vue";
import axios from "axios";
import WElmessage from "@/components/wrappers/w-elmessage.vue";
import { Events } from "@/events/events";
import AxiosUtils from "@/util/axiosUtils";
let OpenQuestionChapterView = class OpenQuestionChapterView extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "chapterId", void 0);
    _defineProperty(this, "quizContentId", void 0);
    _defineProperty(this, "quizContent", void 0);
    _defineProperty(this, "realtimeComplementaryInfo", '');
  }
  mounted() {
    this.getOpenQuestionChapterData();
  }
  get openQuestion() {
    return this.quizContent?.questions?.[0] ?? null;
  }
  get openQuestionDetailEditorId() {
    return `openQuestion-cmplt-info-editor-${this.chapterId}`;
  }
  get openQuestionDetailEditorConfig() {
    return {
      placeholder: this.$t('chapter.openQuestionView.complementaryInfo.placeholder'),
      height: '346px'
    };
  }
  getOpenQuestionChapterData() {
    axios.get(`/api/v2/quiz/${this.quizContentId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      this.quizContent = response.data;
      this.realtimeComplementaryInfo = this.openQuestion?.information || '';
    }, error => {
      AxiosUtils.displayError(error, this.$t('errors.default'));
    });
  }
  onTimeLimitChange(newTimer) {
    axios.patch(`/api/v2/quizz/${this.quizContentId}`, {
      contenuQuizDataJson: JSON.stringify({
        timer: newTimer
      })
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(() => {
      WElmessage.showSuccessMessage(this.$t('chapter.openQuestionView.success.timer'));
      trig(Events.RAFRAICHIR_PLAN_CHAPITRE, this.chapterId);
    }, error => {
      AxiosUtils.displayError(error, this.$t('errors.default'));
    });
  }
  onOpenQuestionLabelChange(newLabel) {
    if (this.openQuestion) {
      this.updateQuestionData(this.openQuestion.id, {
        label: newLabel
      }, this.$t('chapter.openQuestionView.success.questionLabel'));
    }
  }
  onComplementaryInfoChange(text) {
    if (this.openQuestion && text.trim() !== this.realtimeComplementaryInfo.trim()) {
      this.realtimeComplementaryInfo = text.trim();
      this.updateQuestionData(this.openQuestion.id, {
        information: this.realtimeComplementaryInfo
      }, this.$t('chapter.openQuestionView.success.questionInformation'));
    }
  }
  updateQuestionData(questionId, data, successfulMsg) {
    axios.patch(`/api/v2/quiz-questions/${questionId}`, {
      questionDataJson: JSON.stringify(data)
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(() => {
      WElmessage.showSuccessMessage(successfulMsg);
      trig(Events.RAFRAICHIR_PLAN_CHAPITRE, this.chapterId);
    }, error => {
      AxiosUtils.displayError(error, this.$t('errors.default'));
    });
  }
};
__decorate([Prop({
  required: true
})], OpenQuestionChapterView.prototype, "chapterId", void 0);
__decorate([Prop({
  required: true
})], OpenQuestionChapterView.prototype, "quizContentId", void 0);
OpenQuestionChapterView = __decorate([Component({
  components: {
    QuizHtmlEditor,
    WInput
  }
})], OpenQuestionChapterView);
export default OpenQuestionChapterView;